
import formValidate from "@/js/formValidate";
import * as axios from "@/store/http";
export default {
  name: "commonload",
  props: {},
  data() {
    return {
      isDisable: false,
      colon: "：",
      deleteAction: "", //删除的路径
      loadAddAction: "", //单据新增初始化加载路径
      loadAction: "", //单据编辑路径
      saveAction:"", //业务保存链接
      currRouterPath:"",//页面当前路径
      currpathid:"",
      currmoduid: "", //模块ID
      btype: "", //业务类型
      record: {
        rowList: [], //行表信息
        delrowids: [], //传给后端的删除行id，从逗号分隔的字符串，改为数组，
        rowmodel :{} //单据行项模版
      }, //主表信息
      process: {}, //流程信息
      delBillids: "", //单据删除的关键字
      formTipArray: [], //表单校验提示信息
      formValidateInfo: {}, //表单CVIEW校验规则
      aFormValidateTip: [], //表单校验提示信息
      validFormInfo: { //表单校验对象信息
        mainFormName: "record",
        childComponentName: []
      },
      editItemShow: false, //控制行项是否可新增删除
      rules: {}, //流程校验规则
      editItems: "", //无流程编辑项
      notNullItems: "" ,//无流程必填项
      keyname : "id", //默认单据主键billid
      bill_applyuserkey_name : "", //发起人表字段名(无流程单据控制编辑项是否受发起人控制)
      temp:[],
      fileidname:[] //附件主键名
    };
  },
  methods: {
      /**
     * 公用单据加载方法(流程)
     * blankflag  行项是否默认空行
     */
    doLoadRecord4Flow: async function() {
      let oQuery = {};
      let url = "";
      this.record[this.keyname] = this.$route.query[this.keyname];

      if (undefined == this.record[this.keyname] || "" == this.record[this.keyname]) {
        //新增
        oQuery.applydeptid = this.$route.query.applydeptid;
        this.process.flow_currdeptid = this.$route.query.applydeptid;
        url = this.loadAddAction;
      } else {
        url = this.loadAction;
      }
      oQuery.record = this.record;
      oQuery.process = this.process;

      if(this.doLoadRecordBefore(oQuery,this.$route.query)){ 
        await this.axios.post(url, oQuery).then(({ data }) => {
          if (data.code != "1") {
            //装载失败
            console.log(data.msg);
            return false;
          } else {
            this.currmoduid = data.data.pub_moduid; 
            this.btype = data.data.flow_btype;
            this.record = data.data.record;
            
            this.process = data.data.process;
            this.record.delrowids = [];
            console.log(this.record,"myererererer")
            //判断行项是否有新增行项的编辑权限
            if (
              this.process.editItems != undefined &&
              this.process.editItems != null &&
              this.process.editItems.indexOf(";ADD;") != -1
            ) {
              this.editItemShow = true;
            }
            console.info(data.data.formValidateInfo);
            //初始化校验
            this.$formValidate.initViewInfo4Flow(
              this,
              data.data.formValidateInfo
            );

            this.doLoadRecordAfter(oQuery, data);
          }
        });
      } 
    },
    /**
     * 公用单据加载方法(无流程)
     * blankflag  行项是否默认空行
     */
    doLoadRecordNot4Flow: async function() {
      let oQuery = {};
      let url = "";
      this.record[this.keyname] = this.$route.query[this.keyname];
      if (undefined == this.record[this.keyname] || "" == this.record[this.keyname]) {
        //新增
        this.record.applydeptid = this.$route.query.applydeptid;
        url = this.loadAddAction;
      } else {
        url = this.loadAction;
      } 
      oQuery.record = this.record;
      oQuery.editItems = this.editItems;
      oQuery.notNullItems = this.notNullItems;
       
      if(this.doLoadRecordBefore(oQuery,this.$route.query)){
        await this.axios.post(url, oQuery).then(({ data }) => {
          if (data.code != "1") {
            //装载失败
            console.log(data.msg);
            return false;
          } else {
            this.currmoduid = data.data.pub_moduid;
            this.btype = data.data.btype; 
            this.bill_applyuserkey_name = data.data.bill_applyuserkey_name;
            this.record = data.data.record;
            this.editItems = data.data.edititems; //无流程单据编辑项加载
            this.notNullItems = data.data.notNullItems; //无流程单据必填项加载
            this.record.delrowids = [];
            //初始化无流程编辑项信息
            //判断行项是否有新增行项的编辑权限
            if (
              this.editItems != undefined &&
              this.editItems != null &&
              this.editItems.indexOf(";ADD;") != -1
            ) {
              this.editItemShow = true;
            }
            this.$formValidate.initViewInfo4NotFlow2(
              this,
              data.data.formValidateInfo
            );

            this.doLoadRecordAfter(oQuery, data);
          }
        });
      } 
    },

     /**
     * 公用单据加载方法(执行前调用方式)
     * oQuery : 后端交互请求参数对象
     * reuestParams : Url链接请求参数
     */
    doLoadRecordBefore: function(oQuery,reuestParams) {
      return true;
    },

    /**
     * 公用单据加载方法(执行后调用方式)
     * oQuery : 后端交互请求参数对象
     * data ：后端返回数据
     */
    doLoadRecordAfter: async function(oQuery, data) {
      //重新赋值附件的ID
      let t_record = oQuery.record;
      if(this.fileidname && this.fileidname.length >0){
        for(var i = 0  ; i < this.fileidname.length; i++){
            let attr  = this.fileidname[i];
            if(t_record && t_record[attr] && t_record[attr] != ''){
               this.$set(this.record,attr,t_record[attr]);
            }
        }
      }
    },
    validateNotFlowForm: async function(vm, formName) {
    if (vm.aFormValidateTip) {
        vm.aFormValidateTip = [];
    }
    let isValidateSucc = false;
    vm.$refs[formName].validate((valid) => {
        isValidateSucc = valid;
        if (valid) {
            //vm.tipRight(vm.$t('formValidate.success'),vm.$t('formValidate.savesuccess'),'success');
        } else {
            let strHtmlMsg = "";
            for (var i = 0; i < vm.formTipArray.length; i++) {
                  strHtmlMsg += "<p id='ID_error_msg'>" + vm.formTipArray[i] + "</p>"
            }
            let sTipTitle = vm.$t('formValidate.tipTitle');
            let oFormValidateTip = vm.tipError(strHtmlMsg);
            vm.aFormValidateTip.push(oFormValidateTip);
            vm.formTipArray.length = 0;
        }
    });
      return isValidateSucc;
    },

  validateBynosession: async function(vm, validFormInfo) {
    vm.formTipArray = [];
    let isValidateSucc = false;
    let strHtmlMsg = "";
    let mainform = validFormInfo.mainFormName;
    let maintitle = validFormInfo.title;
    //首先校验主单据
    vm.$refs[mainform].validate((valid) => {
        isValidateSucc = valid;
        if (!valid) {
            strHtmlMsg +="<p class='maintitleStyle'>"+maintitle+"</p><br>"
            for (var i = 0; i < vm.formTipArray.length; i++) {
                  strHtmlMsg += "<p id='ID_error_msg'>" + vm.formTipArray[i] + "</p>"
            }
        }
    });
    //逐一校验子组件
    let subcomponents = this.validFormInfo.childComponentName;
    if (subcomponents) {
       for (let currcompont of subcomponents) {
         vm.formTipArray = [];
         let formname = currcompont.componentname;
         let formtitle = currcompont.title;
         await vm.$refs[formname].$refs["ruleForm"].validate((valid) => {
            if(isValidateSucc){
                isValidateSucc = valid;
            }
            if(!valid){
              strHtmlMsg +="<p class='formtitleStyle'>"+formtitle+"</p><br>"
              for (var i = 0; i < vm.formTipArray.length; i++) {
                    strHtmlMsg += "<p id='ID_error_msg'>" + vm.formTipArray[i] + "</p>"
              }
            }
         });
       }
    }
    if(!isValidateSucc){
      let oFormValidateTip = vm.$notify.error({
              title: "Information Verification",
              dangerouslyUseHTMLString: true,
              message: strHtmlMsg,
              duration: 10000,
              customClass:"verificationStyle"
          });
    }
    return isValidateSucc;
    },
    /**
      * 保存业务单据
      */
      saveorsubmitBynoSession: async function(v_act){
        // let loadingInstance = Loading.service({ fullscreen: true });
        //保存业务数据
        this.isDisable = true
          setTimeout(() => {
            this.isDisable = false
        }, 1000)
        let params = {
            act : v_act,
            record : this.record,
            process: this.process
          };
        try {
            if(!await this.beforesave()){
                return;
            }
        } catch (error) {}
        let flag = true;
        // if(v_act === 'submit'){
        //   flag =  await this.tipCustomConfirmNew("default", this.$t("hrcommon.submitbilltip"), "").then ((res) => {
        //     return res;
        //   });
        // }
        if(flag ===  true || v_act === 'save'){
          //保存的时候不绑定必填的规则
          //if(v_act === 'save'){
            await formValidate.bindRules4NotFlow(this,v_act);
           // await formValidate.clearFormValidateTip(this);
         // }
          this.formTipArray.length=0;
          let flag =await this.validateBynosession(this,this.validFormInfo);
          if(flag === true){
                  axios.post(this.saveAction, params).then(({ data }) => {
                  var code = data.code;
                  console.info(code);
                  if (code != "1") {
                      // loadingInstance.close();
                      //返回失败
                      this.returnflag = false;
                  } else {
                      //  loadingInstance.close();
                      // this.dialogVisible= true;
                      this.params = data.data.params;
                      //重新设置record的主键的值
                      this.$router.push({
                        path: this.currRouterPath,
                        query: this.params
                      });
                      //动态设置服务端返回来的参数值
                      var returnParams = this.params;
                      for (var key in returnParams) {
                      //遍历json对象的每个key/value对,p为key
                      console.info(key + " " + returnParams[key]);
                      this.record[key] = returnParams[key];
                      }
                      //弹出提示框 进行倒计时
                      if(v_act === 'submit'){
                        this.tipSuccess(this.$t("hrcommon.submitsuccess"));
                      }else{
                        this.tipSuccess(this.$t("flow_process.savesuccess"));
                      }
                      this.dialogVisible = false;
                      this.doLoadRecordNot4Flow();
                     

                  }
                  });
          }
          // this.$nextTick(() => {
          //     Promise.all(this.buildForms())
          //     .then(() => {
                  //保存前校验单据是否加载成功
                  // if(!this.checkBillReload()){
                  //   return;
                  // }
                 
              // })
              // .catch(error => {
              //     if(this.formTipArray.length > 0){
              //         let oFormValidateTip = this.formErrorTip2(
              //         this.$t("flow_process.msgtitle"),
              //         this.formTipArray
              //         );
              //         formValidate.pushFormValidateTip(this, oFormValidateTip);
              //     }else{
              //         this.tipError(this.$t("flow_process.saveerror2"));
              //     }
              // });
         // });
        }
          
      },
     /**
      * 保存业务单据
      */
      saveorsubmitNotFlow: async function(v_act){
        // let loadingInstance = Loading.service({ fullscreen: true });
        //保存业务数据

        let params = {
            act : v_act,
            record : this.record,
            process: this.process
          };
        try {
            if(!await this.beforesave()){
                return;
            }
        } catch (error) {}
        let flag = false;
        if(v_act === 'submit'){
          flag =  await this.tipCustomConfirmNew("default", this.$t("hrcommon.submitbilltip"), "").then ((res) => {
            return res;
          });
        }
        if(flag ===  true || v_act === 'save'){
          //保存的时候不绑定必填的规则
          //if(v_act === 'save'){
            await formValidate.bindRules4NotFlow(this,v_act);
            await formValidate.clearFormValidateTip(this);
         // }
          this.formTipArray.length=0;
        
          this.$nextTick(() => {
              Promise.all(this.buildForms())
              .then(() => {
                  //保存前校验单据是否加载成功
                  // if(!this.checkBillReload()){
                  //   return;
                  // }
                  axios.post(this.saveAction, params).then(({ data }) => {
                  var code = data.code;
                  console.info(code);
                  if (code != "1") {
                      // loadingInstance.close();
                      //返回失败
                      this.returnflag = false;
                  } else {
                      //  loadingInstance.close();
                      // this.dialogVisible= true;
                      this.params = data.data.params;
                      //重新设置record的主键的值
                      this.$router.push({
                        path: this.currRouterPath,
                        query: this.params
                      });
                      //动态设置服务端返回来的参数值
                      var returnParams = this.params;
                      for (var key in returnParams) {
                      //遍历json对象的每个key/value对,p为key
                      console.info(key + " " + returnParams[key]);
                      this.record[key] = returnParams[key];
                      }
                      //弹出提示框 进行倒计时
                      if(v_act === 'submit'){
                        this.tipSuccess(this.$t("hrcommon.submitsuccess"));
                      }else{
                        this.tipSuccess(this.$t("flow_process.savesuccess"));
                      }
                      this.doLoadRecordNot4Flow();
                      this.reloadflag = "1";
                      if(this.portalflag !='portal'){
                          //刷新父窗口
                          window.opener.location.reload();
                      }

                  }
                  });
              })
              .catch(error => {
                  if(this.formTipArray.length > 0){
                      let oFormValidateTip = this.formErrorTip2(
                      this.$t("flow_process.msgtitle"),
                      this.formTipArray
                      );
                      formValidate.pushFormValidateTip(this, oFormValidateTip);
                  }else{
                      this.tipError(this.$t("flow_process.saveerror2"));
                  }
              });
          });
        }
          
      },
      deletebillNotFlow: async function () {
            let oQuery = {};
            let deleteflag = true;

            oQuery.delBillids = this.record[this.keyname];

            try {
                deleteflag = this.beforedelete(oQuery);
            } catch (error) {
                deleteflag = true;
            }
            if(deleteflag){
              this.tipCustomConfirm("default", this.$t('flow_process.deletemsg'), "").then (() => {
                    this.axios.post(this.deleteAction, oQuery).then(({ data }) => {
                        if (data.code == "1") {
                            let closeFlag=true;
                            try {
                                closeFlag=this.afterdelete(oQuery,data);
                            } catch (error) {}
                            //刷新父窗口
                            if(closeFlag){
                                if(this.portalflag !='portal'){
                                    window.opener.location.reload();
                                }
                                //关闭窗口
                                window.close();
                            }
                        } else {
                            console.log("flow_process.deletebill : " , data.msg);
                        }
                    });
                });
            }
        },
       buildForms:function(){
            
            let aForm = [];
            let sMainFormName = this.validFormInfo.mainFormName;
            if (sMainFormName) {
                aForm.push(
                new Promise((resolve, reject) => {
                    this.$refs[sMainFormName].validate(valid => {
                    if (valid) {
                        resolve();
                    } else {
                        reject();
                    }
                    });
                })
                );
            }

            let aChildComponentName = this.validFormInfo.childComponentName;
            if (aChildComponentName) {
                for (let currChildComponentName of aChildComponentName) {
                if (!currChildComponentName) {
                    continue;
                }
                aForm.push(
                    new Promise((resolve, reject) => {
                    this.$refs[currChildComponentName].$refs[
                        "ruleForm"
                    ].validate(valid => {
                        if (valid) {
                        resolve();
                        } else {
                        reject();
                        }
                    });
                    })
                );
                }
            }
            return aForm;
        },
  },
     
  
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/common/commonload.vue